/**
 * Overlay de identificação do módulo (ícone no header com nome da tela).
 * Padrão: ativo só em development. Forçar com `REACT_APP_MODULE_NAME_DISPLAY=true|false`.
 */
export function resolveModuleNameDisplayEnabled(
  nodeEnv: string | undefined,
  moduleNameDisplayFlag: string | undefined
): boolean {
  return (
    moduleNameDisplayFlag === 'true' ||
    (moduleNameDisplayFlag !== 'false' && nodeEnv === 'development')
  );
}
